/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Upgrade_TitleInputs */

const en_interview_upgrade_title = /** @type {(inputs: Interview_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade to Premium to unlock Interview Prep`)
};

const de_interview_upgrade_title = /** @type {(inputs: Interview_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade auf Premium, um Vorstellungsgespräch-Vorbereitung freizuschalten`)
};

const fr_interview_upgrade_title = /** @type {(inputs: Interview_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passe à Premium pour débloquer la préparation d'entretien`)
};

const es_interview_upgrade_title = /** @type {(inputs: Interview_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejore a Premium para desbloquear la preparación de entrevista`)
};

const it_interview_upgrade_title = /** @type {(inputs: Interview_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna a Premium per sbloccare la preparazione al colloquio`)
};

const nl_interview_upgrade_title = /** @type {(inputs: Interview_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade naar Premium om Sollicitatiegespreksvoorbereiding te ontgrendelen`)
};

const pl_interview_upgrade_title = /** @type {(inputs: Interview_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ulepsz do Premium, aby odblokować przygotowanie do rozmowy kwalifikacyjnej`)
};

const fi_interview_upgrade_title = /** @type {(inputs: Interview_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päivitä Premium:iin avataksesi haastatteluvalmistelun`)
};

const da_interview_upgrade_title = /** @type {(inputs: Interview_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opgrader til Premium for at låse Interviewforberedelse op`)
};

const sv_interview_upgrade_title = /** @type {(inputs: Interview_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppgradera till Premium för att låsa upp Intervjuförberedelse`)
};

/**
* | output |
* | --- |
* | "Upgrade to Premium to unlock Interview Prep" |
*
* @param {Interview_Upgrade_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_upgrade_title = /** @type {((inputs?: Interview_Upgrade_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Upgrade_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_upgrade_title(inputs)
	if (locale === "fr") return fr_interview_upgrade_title(inputs)
	if (locale === "es") return es_interview_upgrade_title(inputs)
	if (locale === "it") return it_interview_upgrade_title(inputs)
	if (locale === "nl") return nl_interview_upgrade_title(inputs)
	if (locale === "pl") return pl_interview_upgrade_title(inputs)
	if (locale === "fi") return fi_interview_upgrade_title(inputs)
	if (locale === "da") return da_interview_upgrade_title(inputs)
	if (locale === "sv") return sv_interview_upgrade_title(inputs)
	return en_interview_upgrade_title(inputs)
});